var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardVerticalThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 17.4167C9.16663 18.425 9.99163 19.25 11 19.25C12.0083 19.25 12.8333 18.425 12.8333 17.4167C12.8333 16.4083 12.0083 15.5833 11 15.5833C9.99163 15.5833 9.16663 16.4083 9.16663 17.4167Z",
    stroke: "#E1E1E1",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 4.58268C9.16663 5.59102 9.99163 6.41602 11 6.41602C12.0083 6.41602 12.8333 5.59102 12.8333 4.58268C12.8333 3.57435 12.0083 2.74935 11 2.74935C9.99163 2.74935 9.16663 3.57435 9.16663 4.58268Z",
    stroke: "#E1E1E1",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 11.0007C9.16663 12.009 9.99163 12.834 11 12.834C12.0083 12.834 12.8333 12.009 12.8333 11.0007C12.8333 9.99232 12.0083 9.16732 11 9.16732C9.99163 9.16732 9.16663 9.99232 9.16663 11.0007Z",
    stroke: "#E1E1E1",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardVerticalThreeDots);
export default __webpack_public_path__ + "static/media/dashboard_vertical_three_dots.8ef9e19c8ffd6f074d6f28826512439f.svg";
export { ForwardRef as ReactComponent };